import ageqReportDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0,
  },
};

const ageqReportReducer = ageqReportDispatcher(initialState, {
  [ageqReportDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined,
    },
  }),
  [ageqReportDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value,
  }),
  [ageqReportDispatcher.resetData]: (state, _) => ({
    ...initialState,
  }),
});

export default ageqReportReducer;
